/**
 * Rótulos em português para busca no iNaturalist (locale=pt-BR).
 * Chaves normalizadas: maiúsculas, sem acentos.
 */
export const ANIMAL_KEYWORD_LABELS = {
  LEAO: 'Leão',
  TIGRE: 'Tigre',
  URSO: 'Urso',
  LOBO: 'Lobo',
  RAPOSA: 'Raposa',
  GATO: 'Gato',
  CACHORRO: 'Cão',
  CAVALO: 'Cavalo',
  ZEBRA: 'Zebra',
  ELEFANTE: 'Elefante',
  RINOCERONTE: 'Rinoceronte',
  HIPOPOTAMO: 'Hipopótamo',
  GIRAFA: 'Girafa',
  MACACO: 'Macaco',
  GORILA: 'Gorila',
  COELHO: 'Coelho',
  ESQUILO: 'Esquilo',
  PATO: 'Pato',
  CORUJA: 'Coruja',
  AGUIA: 'Águia',
  VACA: 'Vaca',
  PORCO: 'Porco',
  GALINHA: 'Galinha',
  OVELHA: 'Ovelha',
  BODE: 'Bode',
  BALEIA: 'Baleia',
  GOLFINHO: 'Golfinho',
  TUBARAO: 'Tubarão',
  POLVO: 'Polvo',
  LULA: 'Lula',
  JACARE: 'Jacaré',
  COBRA: 'Cobra',
  SAPO: 'Sapo',
  TARTARUGA: 'Tartaruga',
  FORMIGA: 'Formiga',
  ABELHA: 'Abelha',
  BORBOLETA: 'Borboleta',
  ARANHA: 'Aranha',
  MORCEGO: 'Morcego',
  CAPIVARA: 'Capivara',
  ONCA: 'Onça',
  PANDA: 'Panda',
  PINGUIM: 'Pinguim',
  CANGURU: 'Canguru',
  CAMELO: 'Camelo',
  CROCODILO: 'Crocodilo',
  PANTERA: 'Pantera',
  TUCANO: 'Tucano',
  PAPAGAIO: 'Papagaio',
  LEOPARDO: 'Leopardo',
};

/**
 * Fallback com nome científico quando o autocomplete em português não retorna espécie.
 */
export const ANIMAL_KEYWORD_SCIENTIFIC = {
  URSO: 'Ursus arctos',
  GATO: 'Felis catus',
  CACHORRO: 'Canis lupus familiaris',
  PANTERA: 'Panthera pardus',
  TUBARAO: 'Carcharodon carcharias',
  BALEIA: 'Balaenoptera musculus',
  JACARE: 'Caiman latirostris',
};

const PLANT_AND_FUNGI = new Set(['Plantae', 'Fungi']);

export function normalizeAnimalKeyword(keyword) {
  if (!keyword || typeof keyword !== 'string') {
    return '';
  }

  return keyword
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function getAnimalSearchLabel(keyword) {
  const normalized = normalizeAnimalKeyword(keyword);
  return ANIMAL_KEYWORD_LABELS[normalized] || keyword.trim();
}

export function getAnimalScientificName(keyword) {
  const normalized = normalizeAnimalKeyword(keyword);
  return ANIMAL_KEYWORD_SCIENTIFIC[normalized] || '';
}

export function isAcceptedAnimalTaxon(taxon) {
  if (!taxon?.default_photo?.square_url) {
    return false;
  }

  if (taxon.rank !== 'species' && taxon.rank !== 'subspecies') {
    return false;
  }

  return !PLANT_AND_FUNGI.has(taxon.iconic_taxon_name);
}
